<script>
import AppModal from '@/components/AppModal.vue'
import AppDisplay from '@/components/AppDisplay.vue'
import Cadastro from './Cadastro/Cadastro.vue'
import Processo from './Processo/Processo.vue'
import Historico from './Historico/Historico.vue'

export default {
  components: {
    AppModal,
    AppDisplay,
    Cadastro,
    Processo,
    Historico
  },
  props: {
    infosCadastro: {
      type: Object
    },
    showHeader: {
      type: Boolean,
      default: true
    },
    loading: {
      type: Boolean
    },
    loadingTab: {
      type: Boolean
    },
    actualTab: {
      type: String,
      default: 'CADASTRO'
    },
    versaoCadastro: {
      type: Number,
      default: 1
    },
    cadastro: {
      type: Object
    },
    processo: {
      type: Array
    },
    historico: {
      type: Array
    },
    cadastroContainerCustomClasses: {
      type: [String, Array],
      default: ''
    }
  },
  data () {
    return {
      tab: this.actualTab,
      versao: this.versaoCadastro
    }
  },
  methods: {
    handleChangeTab (tab) {
      this.$emit('update:actualTab', tab.name)
    },
    handleChangeVersao (versao) {
      this.$emit('update:versaoCadastro', versao)
    }
  }
}

</script>

<template>
  <div>
    <div v-if="loading" v-loading="loading" class="container-loader" />
    <div v-else>
      <div v-if="showHeader" class="container card card-informacoes border-radius-4px bg-light-grey">
        <el-col :span="12">
          <app-display label="Processo:" :content="infosCadastro.numeroProcesso" />
          <app-display label="Data de criação:" :content="infosCadastro.dataCadastro" />
        </el-col>
        <el-col :span="12">
          <app-display label="Cadastrante:" :content="infosCadastro.cadastrante" />
          <app-display label="Modalidade do cadastro:" :content="infosCadastro.modalidadeCadastro" />
        </el-col>
      </div>
      <div :class="cadastroContainerCustomClasses">
        <div class="select-versao">
          <el-col :span="4">
            <span>Versão do cadastro:</span>
            <el-select
              v-model="versao"
              @change="handleChangeVersao"
            >
              <el-option
                v-for="versao in infosCadastro.versoes"
                :key="versao.id"
                :label="versao.nome"
                :value="versao.id"
              />
            </el-select>
          </el-col>
        </div>
        <div class="container-tabs">
          <el-tabs v-model="tab" :stretch="true" @tab-click="handleChangeTab">
            <el-tab-pane
              label="Cadastro"
              name="CADASTRO"
              v-loading="loadingTab"
              :class="{loadingTab : 'tab-loader'}"
            >
              <Cadastro :cadastro="JSON.parse(cadastro.json)" :protocolo="infosCadastro.protocolo" :modalidadeCadastro="infosCadastro.modalidadeCadastro" />
            </el-tab-pane>
            <el-tab-pane
              label="Processo"
              name="PROCESSO"
              v-loading="loadingTab"
              :class="{loadingTab : 'tab-loader'}"
            >
              <Processo v-if="processo" :processo="processo" />
            </el-tab-pane>
            <el-tab-pane
              label="Histórico"
              name="HISTORICO"
              v-loading="loadingTab"
              :class="{loadingTab : 'tab-loader'}"
            >
              <Historico v-if="historico" :historico="historico" />
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @import './style.scss';
</style>



// WEBPACK FOOTER //
// src/components(new)/UI/Modals/VisualizacaoCadastro/VisualizacaoCadastro.vue